import { render, staticRenderFns } from "./OutlineButton.vue?vue&type=template&id=8058ef78&"
import script from "./OutlineButton.vue?vue&type=script&lang=js&"
export * from "./OutlineButton.vue?vue&type=script&lang=js&"
import style0 from "./OutlineButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports